import React, { Component, Fragment } from 'react';
import { Box, TableContainer, Table, TableBody, TableRow, TableCell, TableHead, TableFooter } from '@mui/material';
import Dialog from '../../common/Dialog';
import { MONTHS } from '../../../utils/generalFuncs';

class SalaryPreview extends Component {
    state = {  }
    render() {
        const { 
            salary_employee,
            salary_base,
            salary_brut,
            salary_net,
            salary_to_pay,
            salary_lines_brut, 
            salary_lines_net,
            salary_lines_to_pay,
            salary_period_start,
            salary_period_end,
        } = this.props.salary;
        const { EMPLOYEES, SERVICES, FUNCTIONS  } = this.props;
        let employee = EMPLOYEES[salary_employee]
        return (
            <Dialog
                maxWidth="lg"
                open={true}
                close={this.props.handleClose}
                title="Aperçu"
                submitAction={this.props.handleSubmit}
                disabledSubmit={this.props.STATE.salaries.fetching}
            >
                <TableContainer>
                    <Table className="salaryTable">
                        <TableBody>
                            <TableRow className="title">
                                <TableCell colSpan={4}>BULLETIN DE PAIE</TableCell>
                                <TableCell colSpan={4}>{MONTHS[salary_period_end.getMonth()]} {salary_period_end.getFullYear()}</TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Matricule</TableCell>
                                <TableCell colSpan={2}>: {employee.employee_matricule}</TableCell>
                                <TableCell colSpan={2} component="th">Catégorie</TableCell>
                                <TableCell colSpan={2}>:</TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Nom et Prénom(s)</TableCell>
                                <TableCell colSpan={2}>: {employee.employee_lastname} {employee.employee_firstname}</TableCell>
                                <TableCell colSpan={2} component="th">Salaire de Base</TableCell>
                                <TableCell colSpan={2}>: {salary_base.toLocaleString("fr-FR")}</TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Date d'Embauche</TableCell>
                                <TableCell colSpan={2}>: {new Date(employee.employee_hire_date).toLocaleDateString("fr-FR")}</TableCell>
                                <TableCell colSpan={2} component="th">N° CNSS</TableCell>
                                <TableCell colSpan={2}>:</TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Situation Matr</TableCell>
                                <TableCell colSpan={2}>:</TableCell>
                                <TableCell colSpan={2} component="th">Mode de Réglement</TableCell>
                                <TableCell colSpan={2}>:</TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Service</TableCell>
                                <TableCell colSpan={2}>: {SERVICES && SERVICES[employee.employee_service].service_name}</TableCell>
                                <TableCell colSpan={2} component="th">N° Compte</TableCell>
                                <TableCell colSpan={2}>: </TableCell>
                            </TableRow>
                            <TableRow className="noBorder">
                                <TableCell colSpan={2} component="th">Fonction</TableCell>
                                <TableCell colSpan={2}>: {FUNCTIONS && FUNCTIONS[employee.employee_function].function_name}</TableCell>
                                <TableCell colSpan={2} component="th">Banque</TableCell>
                                <TableCell colSpan={2}>:</TableCell>
                            </TableRow>
                            <TableRow className="title">
                                <TableCell colSpan={3}>Rubrique</TableCell>
                                <TableCell>Base</TableCell>
                                <TableCell>Qté ou Taux</TableCell>
                                <TableCell>Retenue</TableCell>
                                <TableCell>Gain</TableCell>
                                <TableCell>Part Employeur</TableCell>
                            </TableRow>
                            <TableRow className="total">
                                <TableCell colSpan={3}>Salaire de Base</TableCell>
                                <TableCell align="right">{salary_base.toLocaleString("fr-FR")}</TableCell>
                                <TableCell align="center">1</TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">{salary_base.toLocaleString("fr-FR")}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            {salary_lines_brut.map( line => (
                                <TableRow>
                                    <TableCell colSpan={3}>{line.salary_line_name.label}</TableCell>
                                    <TableCell align="right">{line.salary_line_base.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_rate.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_retenue.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_gain.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_employer.toLocaleString("fr-FR")}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow className="total">
                                <TableCell colSpan={3}>SALAIRE BRUT</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">{salary_brut.toLocaleString("fr-FR")}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            {salary_lines_net.map( line => (
                                <TableRow>
                                    <TableCell colSpan={3}>{line.salary_line_name.label}</TableCell>
                                    <TableCell align="right">{line.salary_line_base.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_rate.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_retenue.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_gain.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_employer.toLocaleString("fr-FR")}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow className="total">
                                <TableCell colSpan={3}>SALAIRE NET</TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">{salary_net.toLocaleString("fr-FR")}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            {salary_lines_to_pay.map( line => (
                                <TableRow>
                                    <TableCell colSpan={3}>{line.salary_line_name.label}</TableCell>
                                    <TableCell align="right">{line.salary_line_base.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_rate.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_retenue.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_gain.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="right">{line.salary_line_employer.toLocaleString("fr-FR")}</TableCell>
                                </TableRow>
                            ))}
                            <TableRow className="total">
                                <TableCell colSpan={5}>MONTANT À PAYER</TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">{salary_to_pay.toLocaleString("fr-FR")}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Dialog>
        );
    }
}

export default SalaryPreview;